module.exports = __webpack_public_path__ + "img/icon-circle-flag.49b6875.png";